<template>
    <section class="rtb-form-section" data-field="name">
        <div class="field">
            <label class="field__label" for="rtb-form-name">Название</label>
            <input
                id="rtb-form-name"
                :value="form.name"
                type="text"
                class="form-input"
                maxlength="255"
                placeholder="Название кампании"
                :disabled="disabled"
                :class="{ 'is-invalid': errors.name }"
                @input="onNameInput"
            />
            <p v-if="errors.name" class="field__error">{{ errors.name }}</p>
        </div>

        <div class="rtb-form-section__row">
            <div class="field" data-field="advertiser_id">
                <label class="field__label" for="rtb-form-advertiser">Рекламодатель</label>
                <select
                    id="rtb-form-advertiser"
                    v-model="form.advertiser_id"
                    class="select-input"
                    :disabled="disabled"
                    :class="{ 'is-invalid': errors.advertiser_id }"
                    @change="emit('advertiser-change')"
                >
                    <option :value="null">— Не выбран —</option>
                    <option v-for="advertiser in advertisers" :key="advertiser.id" :value="advertiser.id">
                        {{ advertiser.name }}
                    </option>
                </select>
                <p v-if="errors.advertiser_id" class="field__error">{{ errors.advertiser_id }}</p>
            </div>
            <div class="field" data-field="brand_id">
                <label class="field__label" for="rtb-form-brand">Бренд</label>
                <select
                    id="rtb-form-brand"
                    v-model="form.brand_id"
                    class="select-input"
                    :disabled="disabled || !brands.length"
                    :class="{ 'is-invalid': errors.brand_id }"
                >
                    <option :value="null">— Не выбран —</option>
                    <option v-for="brand in brands" :key="brand.id" :value="brand.id">{{ brand.name }}</option>
                </select>
                <p v-if="errors.brand_id" class="field__error">{{ errors.brand_id }}</p>
            </div>
        </div>

        <div class="rtb-form-section__row">
            <div class="field">
                <label class="field__label" for="rtb-form-status">Статус</label>
                <select id="rtb-form-status" v-model="form.status" class="select-input" :disabled="disabled">
                    <option v-for="option in RTB_USER_STATUS_OPTIONS" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
                </select>
            </div>
            <div v-if="isEdit && isAdmin" class="field">
                <label class="field__label" for="rtb-form-system-status">Статус модерации</label>
                <select id="rtb-form-system-status" v-model="form.system_status" class="select-input" :disabled="disabled">
                    <option v-for="option in RTB_SYSTEM_STATUS_OPTIONS" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
                </select>
            </div>
        </div>
    </section>
</template>

<script setup>
import { RTB_CAMPAIGN_NAME_DISALLOWED, RTB_SYSTEM_STATUS_OPTIONS, RTB_USER_STATUS_OPTIONS } from '../../../../constants/rtbCampaigns';

const props = defineProps({
    form: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    advertisers: { type: Array, default: () => [] },
    brands: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    isAdmin: { type: Boolean, default: false },
});

const emit = defineEmits(['advertiser-change']);

const onNameInput = (event) => {
    const cleaned = String(event.target.value).replace(RTB_CAMPAIGN_NAME_DISALLOWED, '');
    props.form.name = cleaned;
    if (event.target.value !== cleaned) event.target.value = cleaned;
};
</script>
